// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"dcd19bef","511":"ecbbbd0e","548":"1272f351","720":"763c74e2","817":"e972773d"}[chunkId] + ".chunk.js";
};